import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RaceCard from "./RaceCard";
import { getRacesByType, getAllRaces } from "../services/GridServices";
import "./RaceGrid.css";

const RaceGrid = ({ viewMode = "grid", raceType = "all", onPlaceBet }) => {
  const [races, setRaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRaces = async () => {
      try {
        setLoading(true);
        setError(null);

        const raceData =
          raceType === "all"
            ? await getAllRaces()
            : await getRacesByType(raceType);

        setRaces(raceData);
      } catch (err) {
        setError("Failed to load races. Please try again later.");
        console.error("Error fetching races:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRaces();
  }, [raceType]);

  if (loading) {
    return (
      <div className="race-grid-container">
        <div className="race-grid-loading">
          <div className="loading-spinner"></div>
          <p>Loading races...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="race-grid-container">
        <div className="race-grid-error">
          <p>{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="retry-button"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!races.length) {
    return (
      <div className="race-grid-container">
        <div className="race-grid-empty">
          <p>No races found for this category.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="race-grid-container">
      <div
        className={`race-grid ${
          viewMode === "list" ? "list-view" : "grid-view"
        }`}
      >
        {races.map((race) => (
          <div key={race.id} className="race-grid-item">
            <RaceCard
              title={race.title}
              amount={race.amount}
              timeLeft={race.timeLeft}
              poolData={race.poolData}
              onPlaceBet={() => onPlaceBet(race.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

RaceGrid.propTypes = {
  viewMode: PropTypes.oneOf(["grid", "list"]),
  raceType: PropTypes.oneOf(["all", "marketCap", "altcoin", "meme", "defi"]),
  onPlaceBet: PropTypes.func.isRequired,
};

RaceGrid.defaultProps = {
  viewMode: "grid",
  raceType: "all",
};

export default RaceGrid;
